import { Observable } from 'rxjs';
import { PromotionModel } from '../../models';

export abstract class BasePromotionService {
  public abstract getAnnoucementBanner(): Observable<PromotionModel[]>;
  public abstract getHomePagePromotions(): Observable<PromotionModel[]>;
  public abstract getSearchResultsPromotion(): Observable<PromotionModel[]>;
  public abstract getPreFooterPromotions(): Observable<PromotionModel[]>;
  public abstract getSpecialtyPromotions(): Observable<PromotionModel[]>;
  public abstract getSystemWideMessage(): Observable<PromotionModel[]>;
}
